<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>
                <span @click="handleTitleClick" style="cursor: default; user-select: none;">额度购买订单</span>
                <el-tag v-if="testMode" type="danger" size="mini" style="margin-left: 8px;">测试模式</el-tag>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <div class="filter-bar">
                <el-row :gutter="12">
                    <el-col :span="24">
                        <el-input placeholder="订单号" clearable v-model="queryInfo.orderNo" @clear="getList()" style="width: 200px;">
                            <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                        </el-input>
                        <el-select v-model="queryInfo.storeId" clearable filterable placeholder="选择门店" class="filter-item" style="width: 180px" @change="getList()">
                            <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                        </el-select>
                        <el-select v-model="queryInfo.payStatus" clearable placeholder="到账状态" class="filter-item" style="width: 130px" @change="getList()">
                            <el-option label="支付中" :value="0"></el-option>
                            <el-option label="已到账" :value="1"></el-option>
                            <el-option label="已取消" :value="2"></el-option>
                        </el-select>
                        <el-select v-model="queryInfo.refundStatus" clearable placeholder="退款状态" class="filter-item" style="width: 130px" @change="getList()">
                            <el-option label="未退款" :value="0"></el-option>
                            <el-option label="已退款" :value="1"></el-option>
                            <el-option label="无需退款" :value="2"></el-option>
                        </el-select>
                        <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="下单开始"
                            end-placeholder="下单结束"
                            value-format="yyyy-MM-dd"
                            @change="onDateChange"
                            class="filter-item"
                        >
                        </el-date-picker>
                        <el-button type="primary" icon="el-icon-upload2" @click="exportExcel" :loading="exporting" v-permission="'btn:order:quotabuyorders:export'" class="filter-item">
                            导出Excel
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            <el-table :data="list" style="width: 100%" stripe size="middle" max-height="640">
                <el-table-column label="订单号" prop="orderNo" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="门店" prop="storeName" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="卡种" prop="cardTypeName" width="90"></el-table-column>
                <el-table-column label="发卡人" prop="issuerUsername" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="单价" width="100" align="right">
                    <template slot-scope="scope">{{ formatMoney(scope.row.unitPrice) }}</template>
                </el-table-column>
                <el-table-column label="张数" prop="count" width="70" align="center"></el-table-column>
                <el-table-column label="金额" width="110" align="right">
                    <template slot-scope="scope">{{ formatMoney(scope.row.amount) }}</template>
                </el-table-column>
                <el-table-column label="到账状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.payStatus == 1" type="success">{{ scope.row.payStatusText }}</el-tag>
                        <el-tag v-else-if="scope.row.payStatus == 0" type="warning">{{ scope.row.payStatusText }}</el-tag>
                        <el-tag v-else type="info">{{ scope.row.payStatusText }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="退款状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.refundStatus == 1" type="danger">已退款</el-tag>
                        <el-tag v-else-if="scope.row.payStatus == 1" type="success">未退款</el-tag>
                        <span v-else style="color:#bbb;font-size:12px">无需退款</span>
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" width="160">
                    <template slot-scope="scope">{{ scope.row.createTime | dateFormat }}</template>
                </el-table-column>
                <el-table-column label="到账时间" width="160">
                    <template slot-scope="scope">{{ scope.row.payTime | dateFormat }}</template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.payStatus == 1 && scope.row.refundStatus != 1 && scope.row.issueStatus != 1 && (scope.row.remaining === null || scope.row.remaining > 0 || testMode)"
                            :type="testMode && scope.row.remaining <= 0 ? 'warning' : 'danger'"
                            size="mini"
                            @click="openRefundDialog(scope.row)"
                            v-permission="'btn:order:quotabuyorders:refund'">
                            {{ testMode && scope.row.remaining <= 0 ? '测试退款' : '退款' }}
                        </el-button>
                        <span v-else style="color:#bbb;font-size:12px">-</span>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum" :page-sizes="[20, 50, 100]" :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!--退款弹窗-->
        <el-dialog title="额度购买订单退款" :visible.sync="refundDialogVisible" width="480px" @close="resetRefundForm">
            <el-form :model="refundModel" :rules="refundRules" ref="refundFormRef" label-width="100px">
                <el-form-item label="订单号">
                    <el-input :value="refundModel.orderNo" disabled></el-input>
                </el-form-item>
                <el-form-item label="订单金额">
                    <el-input :value="refundModel.amount" disabled></el-input>
                </el-form-item>
                <el-form-item label="退款金额" prop="refundAmount">
                    <el-input v-model="refundModel.refundAmount" placeholder="请输入退款金额"></el-input>
                </el-form-item>
                <el-form-item label="退款原因" prop="refundReason">
                    <el-input type="textarea" v-model="refundModel.refundReason" :rows="3" placeholder="请输入退款原因"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="refundDialogVisible = false">取 消</el-button>
                <el-button type="danger" @click="submitRefund" :loading="refunding">确认退款</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from "axios";
import { saveAs } from "file-saver";
import { Loading } from "element-ui";

export default {
    data() {
        return {
            queryInfo: {
                orderNo: '',
                storeId: '',
                payStatus: '',
                refundStatus: '',
                createStart: '',
                createEnd: '',
                pageNum: 1,
                pageSize: 20
            },
            dateRange: [],
            total: 0,
            list: [],
            storelist: [],
            exporting: false,
            refundDialogVisible: false,
            refunding: false,
            refundModel: {
                id: null,
                orderNo: '',
                amount: '',
                refundAmount: '',
                refundReason: ''
            },
            refundRules: {
                refundAmount: [
                    { required: true, message: '请输入退款金额', trigger: 'blur' },
                    { pattern: /^(([1-9]\d*)|0)(\.\d{1,2})?$/, message: '退款金额格式不正确', trigger: 'blur' }
                ],
                refundReason: [
                    { required: true, message: '请输入退款原因', trigger: 'blur' }
                ]
            },
            testMode: false,
            titleClickCount: 0,
            titleClickTimer: null
        }
    },
    created() {
        this.testMode = sessionStorage.getItem('quotaRefundTestMode') === 'true'
        this.getList()
        this.getStoreList()
    },
    methods: {
        onDateChange(val) {
            if (val && val.length === 2) {
                this.queryInfo.createStart = val[0]
                this.queryInfo.createEnd = val[1]
            } else {
                this.queryInfo.createStart = ''
                this.queryInfo.createEnd = ''
            }
            this.getList()
        },
        async getList() {
            const { data: res } = await this.$http.get('quotabuyorders', { params: this.queryInfo })
            if (res.code === 0 || res.status === 0) {
                this.total = res.totalSize || 0
                this.list = res.data || []
            }
        },
        formatMoney(val) {
            const n = Number(val)
            if (!isFinite(n)) return val
            return '¥' + n.toFixed(2)
        },
        async getStoreList() {
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data || []
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize
            this.getList()
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage
            this.getList()
        },
        // 连续点击标题3次切换测试模式（内部测试入口）
        handleTitleClick() {
            this.titleClickCount++
            if (this.titleClickTimer) {
                clearTimeout(this.titleClickTimer)
            }
            this.titleClickTimer = setTimeout(() => {
                this.titleClickCount = 0
            }, 2000)
            if (this.titleClickCount >= 3) {
                this.titleClickCount = 0
                this.testMode = !this.testMode
                sessionStorage.setItem('quotaRefundTestMode', String(this.testMode))
                this.$message({
                    message: this.testMode ? '已开启额度退款测试模式' : '已关闭额度退款测试模式',
                    type: this.testMode ? 'warning' : 'success'
                })
            }
        },
        // 打开退款弹窗
        openRefundDialog(row) {
            this.refundModel = {
                id: row.id,
                orderNo: row.orderNo,
                amount: row.amount,
                refundAmount: '',
                refundReason: ''
            }
            this.refundDialogVisible = true
        },
        resetRefundForm() {
            this.$refs.refundFormRef && this.$refs.refundFormRef.clearValidate()
        },
        // 提交退款
        submitRefund() {
            this.$refs.refundFormRef.validate(async valid => {
                if (!valid) return
                this.refunding = true
                try {
                    const { data: res } = await this.$http.post('quotabuyorderrefund', {
                        id: this.refundModel.id,
                        orderNo: this.refundModel.orderNo,
                        refundAmount: this.refundModel.refundAmount,
                        refundReason: this.refundModel.refundReason,
                        testMode: this.testMode
                    })
                    if (res.code === 0 || res.status === 0) {
                        this.$message.success('退款成功')
                        this.refundDialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(res.msg || res.message || '退款失败')
                    }
                } catch (e) {
                    this.$message.error('退款失败，请稍后重试')
                } finally {
                    this.refunding = false
                }
            })
        },
        // 导出Excel
        exportExcel() {
            this.exporting = true
            let downloadLoadingInstance = Loading.service({
                text: "正在下载数据，请稍候",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            })
            axios
                .get("/quotabuyorders/export", {
                    responseType: "blob",
                    params: {
                        orderNo: this.queryInfo.orderNo,
                        storeId: this.queryInfo.storeId,
                        payStatus: this.queryInfo.payStatus,
                        refundStatus: this.queryInfo.refundStatus,
                        createStart: this.queryInfo.createStart,
                        createEnd: this.queryInfo.createEnd
                    }
                })
                .then(async (data) => {
                    this.exporting = false
                    const isBlob = data.data.type !== "application/json"
                    if (isBlob) {
                        const blob = new Blob([data.data])
                        saveAs(blob, `额度购买订单_${new Date().getTime()}.xlsx`)
                    } else {
                        this.$message.error("导出额度购买订单失败")
                    }
                    downloadLoadingInstance.close()
                })
                .catch((r) => {
                    this.exporting = false
                    console.error(r)
                    this.$message.error("下载文件出现错误，请联系管理员！")
                    downloadLoadingInstance.close()
                })
        }
    }
}
</script>

<style scoped>
.filter-bar {
    margin-bottom: 16px;
}
.filter-item {
    margin-left: 10px;
}
.filter-item:first-child {
    margin-left: 0;
}
</style>
